import { ArrowUpRight, Menu, MessageCircle, X } from "lucide-react";
import { CONTACT, WHATSAPP_URL } from "@/data/siteData";
import BrandMark from "@/components/BrandMark";
import { useEffect, useState } from "react";

const navItems = [
  ["Services", "services"],
  ["The standard", "standard"],
  ["Manifesto", "manifesto"],
  ["Testimonials", "testimonials"],
  ["Service areas", "areas"],
];

export default function SiteHeader({ onQuote }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setMobileOpen(false);

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`} data-testid="site-header">
      <div className="site-header__inner section-shell">
        <a href="#top" className="site-header__brand" onClick={closeMenu} aria-label="Return to top" data-testid="navbar-brand-logo">
          <BrandMark />
        </a>
        <nav className="site-header__nav" aria-label="Primary navigation">
          {navItems.map(([label, id]) => <a href={`#${id}`} key={id} data-testid={`nav-${id}-link`}>{label}</a>)}
        </nav>
        <div className="site-header__actions">
          <a className="header-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="navbar-whatsapp-button"><MessageCircle size={15} /> <span>WhatsApp</span></a>
          <button className="button button--gold button--small" type="button" onClick={() => onQuote()} data-testid="navbar-quote-button">Request a quote <ArrowUpRight size={16} /></button>
        </div>
        <button className="mobile-toggle" type="button" aria-expanded={mobileOpen} aria-label={mobileOpen ? "Close navigation" : "Open navigation"} onClick={() => setMobileOpen((value) => !value)} data-testid="navbar-mobile-toggle">
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="mobile-panel">
          {navItems.map(([label, id]) => <a href={`#${id}`} onClick={closeMenu} key={id} data-testid={`mobile-nav-${id}-link`}>{label}</a>)}
          <a className="mobile-panel__contact" href={CONTACT.phoneHref} onClick={closeMenu} data-testid="mobile-phone-link">Call {CONTACT.phoneDisplay}</a>
          <button className="button button--gold" type="button" onClick={() => { closeMenu(); onQuote(); }} data-testid="mobile-quote-button">Request a quote <ArrowUpRight size={16} /></button>
        </div>
      )}
    </header>
  );
}
